<template>
  <div class="report-container">
    <h2 class="title">📊 Rapport Mensuel</h2>
    <p class="subtitle">Aperçu rapide de la performance du café</p>

    <button class="btn-refresh" @click="fetchReport">
      🔄 Actualiser le rapport
    </button>

    <div class="card-grid">
      <div class="info-card blue">
        <div class="icon">☕</div>
        <div class="content">
          <p class="label">Café acheté</p>
          <p class="value">{{ report.total_coffee }} kg</p>
        </div>
      </div>

      <div class="info-card green">
        <div class="icon">💰</div>
        <div class="content">
          <p class="label">Recettes totales</p>
          <p class="value">{{ report.total_income }} MAD</p>
        </div>
      </div>

      <div class="info-card yellow">
        <div class="icon">💸</div>
        <div class="content">
          <p class="label">Charges totales</p>
          <p class="value">{{ report.total_expenses }} MAD</p>
        </div>
      </div>

      <div class="info-card profit">
        <div class="icon">📈</div>
        <div class="content">
          <p class="label">Bénéfice net</p>
          <p class="value">{{ report.net_profit }} MAD</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MonthlyReport",
  computed: {
    ...mapGetters("report", ["getReport"]),
    report() {
      return this.getReport;
    },
  },
  methods: {
    ...mapActions("report", ["fetchReport"]),
  },
  created() {
    this.fetchReport();
  },
};
</script>

<style scoped>
.report-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  padding: 25px 20px 60px;
  font-family: "Poppins", Avenir, Helvetica, sans-serif;
  color: #2b2b2b;
}

/* Titles */
.title {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 6px;
}

.subtitle {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 25px;
}

/* Refresh Button */
.btn-refresh {
  display: block;
  margin: 0 auto 30px;
  background: linear-gradient(135deg, #4e73df, #2e59d9);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-refresh:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(46, 89, 217, 0.3);
}

/* Grid of cards */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 18px;
}

/* Cards */
.info-card {
  background: #fff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.3s ease;
}
.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.icon {
  font-size: 26px;
}

.label {
  font-size: 13px;
  color: #6c757d;
  margin: 0;
}

.value {
  font-size: 17px;
  font-weight: 700;
  margin: 2px 0 0;
}

/* Color Themes */
.info-card.blue {
  border-left: 6px solid #4e73df;
}
.info-card.green {
  border-left: 6px solid #1cc88a;
}
.info-card.yellow {
  border-left: 6px solid #f6c23e;
}
.info-card.profit {
  background: linear-gradient(135deg, #1cc88a, #17a673);
  color: white;
  border-left: none;
}
.info-card.profit .label {
  color: #e6fff2;
}
.info-card.profit .value {
  color: #fff;
}
</style>
